import { VcfMeasurementsError } from '../errors/VcfMeasurementsError';
import { IMeasurementsResponse, VcfMeasurementsClient } from './VcfMeasurementsClient';

export interface IMeasurementsRange {
    readonly lastUpdate: string;
    readonly value: number;
}

export class VcfMeasurementsService {
    constructor(private readonly vcfMeasurementsClient: VcfMeasurementsClient) {}

    public async getMeasurementsRange(vin: string): Promise<IMeasurementsRange> {
        const ranges = [
            'cngRange_km',
            'dieselRange_km',
            'electricRange_km',
            'gasRange_km',
            'gasolineRange_km',
            'lpgRange_km',
            'petrolRange_km',
        ];
        const measurementsStatusResponse = await this.vcfMeasurementsClient.getMeasurementsStatus(vin);
        try {
            const data = measurementsStatusResponse.data?.find((array) => array.id === 'range');
            if (!data) throw new VcfMeasurementsError('Could not get "data" object from the API');
            const lastUpdate = data.carCapturedTimestamp;
            let value: number = 0;
            ranges.forEach((range) => {
                value += parseInt(data.properties.find((p) => p.name === range)?.value ?? '0');
            });
            return { lastUpdate, value };
        } catch (e: any) {
            throw new VcfMeasurementsError('Could not parse VCF measurements response');
        }
    }

    public async getMeasurementsOdometerRange(vin: string): Promise<IMeasurementsResponse> {
        const measurementsStatusResponse = await this.vcfMeasurementsClient.getMeasurementsStatus(
            vin,
            'odometer,range',
        );
        return measurementsStatusResponse;
    }
}
